import { useSelector } from 'react-redux';

import { getSourceRepositoryAccessLevel } from 'src/redux/pull-request/selectors';
import { RepositoryPrivilege } from 'src/sections/repository/types';
import { checkUserAccess } from 'src/sections/repository/utils/check-user-access';
import { getRepositoryAccessLevel } from 'src/selectors/repository-selectors';

export const useCheckUserAccess = (requiredLevel: RepositoryPrivilege) => {
  const repoAccessLevel = useSelector(getRepositoryAccessLevel);
  const userSourceRepositoryAccessLevel = useSelector(
    getSourceRepositoryAccessLevel
  );

  let userHasAccess = checkUserAccess({
    userLevel: repoAccessLevel,
    requiredLevel,
  });

  if (!userHasAccess) {
    userHasAccess = checkUserAccess({
      userLevel: userSourceRepositoryAccessLevel || 'read',
      requiredLevel,
    });
  }
  return userHasAccess;
};
